import { Box, Card, Grid, styled, Typography } from '@mui/material'
import { type InterestedService } from '../../../core/types'
import S3Image from '../../S3Image'

const StyledCard = styled(Card)(`
padding-right:10px;
  box-shadow:none;
`)
interface InterestFormCardProps {
  notes: string
  services: InterestedService[]
  onClick: () => void
}
export function InterestFormCard (props: InterestFormCardProps): JSX.Element {
  // const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  // const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
  //   setAnchorEl(event.currentTarget)
  // }

  return <StyledCard>
    {/* <Popover
      id={'intakeCardPopover'}
      open={anchorEl != null}
      anchorEl={anchorEl}
      onClose={() => { setAnchorEl(null) }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
    >
      <MenuList>
        <MenuItem onClick={props.onClick}>
          <ListItemText>Dismiss</ListItemText>
        </MenuItem>
      </MenuList>
    </Popover> */}

    <Grid container sx={{ width: '100%', height: '100%', p: '16px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
      {props.notes != null && props.notes !== '' && (<>
        <Grid item>
          <Typography variant='h6'>Child Notes</Typography>
        </Grid>
        <Grid item sx={{ width: '100%', overflowWrap: 'break-word' }}>{props.notes}</Grid>
      </>)}
      {props.services.length > 0 && (<>
        <Grid item>
          <Typography variant='h6'>Services Requested</Typography>
        </Grid>
        {props.services.map(s => {
          return <Grid item>
            <Box sx={{ display: 'flex', flexDirection: 'row', border: '1px solid black', borderRadius: '8px', padding: '16px', gap: 1 }}>
              <Box>
                {s.s3Key != null && s.s3Key !== '' && (
                  <S3Image alt={`${s.name}-service-image`} imageKey={s.s3Key} />
                )}
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Box><Typography variant='h6'>{s.name}</Typography></Box>
                <Box>{s.detail}</Box>
              </Box>
            </Box>
          </Grid>
        })}

      </>)}
    </Grid>
  </StyledCard>
}
